import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NotificationSectionStore} from "./notification-section.store";
import {Serializer} from "../../../interfaces/serializer";
import {Site} from "../../../interfaces/site";
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {Observable} from "rxjs";

@Component({
  selector: 'app-notification-section',
  templateUrl: './notification-section.component.html',
  styleUrls: ['./notification-section.component.scss'],
  providers: [NotificationSectionStore],
  encapsulation: ViewEncapsulation.None
})
export class NotificationSectionComponent implements OnInit {
  public site: Serializer<Site>;

  @Input('site') public set setSite(site: Serializer<Site>) {
    this.site = site;
    this._notificationSectionStore.onInit(this.site);
  }

  public readonly notifications$: Observable<NotificationComponentObject[]> = this._notificationSectionStore.notifications$;
  public opened: boolean = true;

  constructor(
    private readonly _notificationSectionStore: NotificationSectionStore
  ) {}

  public ngOnInit(): void {
    this._notificationSectionStore.onInit(this.site);
  }

  public onToggle(): void {
    this.opened = !this.opened;
  }
}
